import { Divider, List, Toolbar, Box } from '@mui/material';
import Logo from '../../../../assets/logo.jpg';
import { useEffect, useState } from 'react';
import { mainMenuItems } from './ MenuItems';
import { MenuItem } from './SubMenuItem';

export const SidebarContent = ({ handleDrawerToggle, isCollapsed }) => {
  const [openStates, setOpenStates] = useState({});

  useEffect(() => {
    const savedStates = localStorage.getItem('sidebarOpenStates');
    if (savedStates) {
      setOpenStates(JSON.parse(savedStates));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebarOpenStates', JSON.stringify(openStates));
  }, [openStates]);

  const handleToggle = (menuText) => {
    setOpenStates(prev => ({
      ...prev,
      [menuText]: !prev[menuText]
    }));
  };

  useEffect(() => {
    const path = window.location.pathname;
    const parentItem = mainMenuItems.find(item => 
      item.subItems?.some(subItem => subItem.path === path)
    );
    if (parentItem && !openStates[parentItem.text]) {
      setOpenStates(prev => ({ ...prev, [parentItem.text]: true }));
    }
  }, [openStates]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Toolbar 
        sx={{ 
          justifyContent: 'center', 
          pt: 4,
          pb: 3, 
          minHeight: '100px',
          px: isCollapsed ? 0 : 2,
        }}
      >
        <img 
          src={Logo} 
          alt="Koufu Logo" 
          style={{ 
            height: isCollapsed ? '50px' : '70px',
            width: 'auto',
            objectFit: 'contain',
            transition: 'all 0.3s ease',
          }} 
        />
      </Toolbar>
        <Divider/>
      <List sx={{ flexGrow: 1, px: 1 }}>
        {mainMenuItems.map((item) => (
          <MenuItem
            key={item.text}
            item={item}
            isOpen={openStates[item.text] || false}
            onToggle={handleToggle}
            isCollapsed={isCollapsed}
            handleDrawerToggle={handleDrawerToggle}
          />
        ))}
      </List>
    </Box>
  );
};